import loadable from "@loadable/component"

export const InitFCM = loadable(() => import("./init-fcm"))
